import { TopPage } from "@/components/elements/TopPage";

import { Stack } from "@mui/material";
import { FC } from "react";
import { styled } from "@mui/system";
import { CompanyForm } from "@/features/company/components/CompanyForm";

type TCompanyCreateProps = {};

export const CompanyCreate: FC<TCompanyCreateProps> = () => {
  return (
    <CompanyWrapper gap={4}>
      <TopPage
        title="新規顧客の追加"
        description="新しい事業者の基本情報および契約情報を入力してシステムに登録します。登録後、顧客ユーザーの追加も必要です。"
        enablePageBack={false}
      />
      <CompanyForm />
    </CompanyWrapper>
  );
};

const CompanyWrapper = styled(Stack)`
  width: 1198px;
  margin: 0 auto;
`;
